<template>
  <ButtonBase
    class="button-answer"
    :class="{ 'button-answer--animated': animationPercentage === 0 }"
    @click="$emit('question-answered', index, true)"
  >
    <!-- we want to scale the content – not the button size -->
    <div
      class="button-answer__inner"
      :style="{ transform: `scale(${buttonScale}, ${buttonScale}) translate(${translate}px, 0px)` }"
    >
      <div
        class="button-answer__circle"
        :style="{
          transform: `translateX(-50%) translateY(-50%) scale(${circleScale}, ${circleScale})`,
        }"
        :class="{ 'button-answer__animated': circleScale === 0 }"
      />
      <span class="button-answer__label">{{ label }}</span>
    </div>
  </ButtonBase>
</template>

<script>
import ButtonBase from '../ButtonBase';

const SCALE_FACTOR = 4;
const SCALE_DOWN_FACTOR = 0.7;

export default {
  name: 'ButtonAnswer',

  components: {
    ButtonBase,
  },

  props: {
    index: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    animationPercentage: {
      type: Number,
      required: true,
    },
    moveXArea: {
      type: Number,
      required: true,
    },
  },

  computed: {
    translate() {
      return this.animationPercentage * this.moveXArea;
    },

    buttonScale() {
      return 1 + this.animationPercentage * SCALE_DOWN_FACTOR;
    },

    circleScale() {
      let percentageValue = 0;
      if (this.animationPercentage > 0) {
        percentageValue = this.animationPercentage * SCALE_FACTOR;
      }
      if (this.animationPercentage * SCALE_FACTOR >= 1) {
        percentageValue = 1;
      }
      return percentageValue;
    },
  },
};
</script>

<style lang="scss" scoped>
$size: 120px;
$size-inner: 150px;
$size-bp-768: 160px;
$size-bp-768-inner: 190px;
$padding: 2px;

.button-answer {
  position: relative;
  width: $size;
  height: $size;
  padding-left: 0;
  padding-right: 0;

  @include helper__greater($bp-768) {
    width: $size-bp-768;
    height: $size-bp-768;
    .button-answer__circle {
      width: $size-bp-768-inner;
      height: $size-bp-768-inner;
    }
  }
}

a.button-answer {
  cursor: inherit;
}

.button-answer__inner {
  height: 100%;
  cursor: pointer;
}

.button-answer--animated .button-answer__inner,
.button-answer--animated .button-answer__circle {
  transition: all 0.3s ease-in-out;
}

.button-answer__circle {
  position: absolute;
  top: 50%;
  left: 50%;
  width: $size-inner;
  height: $size-inner;
  border-radius: 50%;
  @include radial-gradient();
  @include linear-gradient($color-purple, $color-blue, 45deg);
}

.button-answer__label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  @include answer-label;
  @include radial-gradient();
  color: $color-white;
}
</style>
